// extracted by mini-css-extract-plugin
module.exports = {"root":"ItemContent_root__2XQPx"};